<template>
    <div class="rdvLeads">
        <Header :code="code">{{this.projet.nom}}</Header>
        <v-container v-if='dateSelected'>
            <v-row dense>
                <v-col cols="12">
                    <v-select
                        v-model="dateSelected"
                        :items="date"
                        hide-details
                        outlined
                        dense
                    ></v-select>
                </v-col>
            </v-row>
        </v-container>
        <div v-if='!dateSelected' class="mt-6 text-center">
            Vous n'avez pas de rendez-vous attribués
        </div>
        <div class="expanse" v-for="lead in rdvs[this.dateSelected]" :key="lead.code_lead" >
            <Lead :lead="lead" :code="code" :mode="'rdv'"/> 
        </div>
        <v-btn class="mx-2 btncreate" fab dark depressed small color="primary">
            <v-icon dark @click='$router.push({name:"CreateRdv", params: { code: code }})'>mdi-plus</v-icon>
        </v-btn>
        <Footer01 :code="code"/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Footer01 from '@/components/Footer01'
import Lead from '@/components/Lead'
export default {
    name: 'Rdv',
    props: ['code'],
    components: {
        Header,
        Lead,
        Footer01
    },
    data() {
        return {
            projet: {},
            date: [],
            dateSelected: "",
            rdvs: []
        }
    },
    methods: {
        
    },
    computed: {
        
    },
    watch: {
        
    },
    created() {
        if(Object.keys(this.$store.state.leads).length === 0) {
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=> {
                    this.$store.dispatch('setLoader', false)
                    this.date = this.$store.getters.getAllRdvDate
                    this.rdvs = this.$store.getters.leadsWithRdv
                    this.dateSelected = this.date[0]
                })
            })
        } else {
            this.date = this.$store.getters.getAllRdvDate
            this.rdvs = this.$store.getters.leadsWithRdv
            this.dateSelected = this.date[0]
        }
        if(this.$store.state.loader){
            this.$store.dispatch('setLoader', false)
        }
        this.projet = this.$store.state.projets.find((e) => {
            return e.code_projet == this.code
        })
    },
}
</script>
<style lang="scss">
    .rdvLeads {
        padding: 8vh 0;
    }
</style>